module.exports = __webpack_public_path__ + "img/IMG_4014.2ffbd6a4.jpg";